import { bindRequestLogic } from './utils'
import RiderType from '../actionTypes/rider'
import { riderAPI } from '../api'

const getRiderList = bindRequestLogic({
  clientFunc: riderAPI.getRiderList,
  type: RiderType.GET_RIDER_LIST_REQUEST,
  successType: RiderType.GET_RIDER_LIST_SUCCESS,
  failType: RiderType.GET_RIDER_LIST_FAILED,
  isQueryParam: true
})

export const getRiderDetail = bindRequestLogic({
  clientFunc: riderAPI.getRiderDetail,
  type: RiderType.GET_RIDER_DETAIL_REQUEST,
  successType: RiderType.GET_RIDER_DETAIL_SUCCESS,
  failType: RiderType.GET_RIDER_DETAIL_FAILED
})

export const getRiderPortalRole = bindRequestLogic({
  clientFunc: riderAPI.getRiderPortalRole,
  type: RiderType.GET_RIDER_PORTAL_ROLE_REQUEST,
  successType: RiderType.GET_RIDER_PORTAL_ROLE_SUCCESS,
  failType: RiderType.GET_RIDER_PORTAL_ROLE_FAILED
})

export default [getRiderList, getRiderDetail, getRiderPortalRole]
